import React, {PureComponent} from "react";
import {Box, Card, Typography} from "@mui/material";
import {StyledBoxColumn} from "../shared/StyledComponents";
import {PD_XLG, PD_XLG2} from "../shared/dimens";

import {Game} from "./types";

export type GameCardProps = {
  style?: any,
  game: Game,
  children?: any,
  onClick: () => void,
}

export class GameCard extends PureComponent<GameCardProps> {

  render() {
    const game = this.props.game;
    return <Card style={{borderRadius: 12, cursor: "pointer", ...this.props.style}}
                 onClick={() => this.props.onClick()}>
      <Box style={{display: "flex", flexDirection: "column", width: "100%", position: "relative"}}>
        <StyledBoxColumn style={{position: "relative", background: game.color, alignItems: "center", gap: PD_XLG}}>
          <img src={game.coverUrl} style={{width: "100%", aspectRatio: 4 / 3, objectFit: "cover"}}/>
          <Typography
            variant="h4"
            style={{
              position: "absolute",
              textAlign: "center",
              bottom: 0,
              paddingTop: 96,
              width: "100%",
              // color: "white",
              background: "linear-gradient(rgba(255, 255, 255, 0),rgba(255, 255, 255,1)"
            }}>
            {game.name}
          </Typography>
        </StyledBoxColumn>
        {this.props.children}
      </Box>
    </Card>
  }
}